import { FolderOpenFilled } from '@ant-design/icons';
import { Delete } from '@mui/icons-material';
import ContentCopy from '@mui/icons-material/ContentCopy';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, TableCell, TableRow } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';
import { CompanyDefinition, SheetStatus } from 'utils/StringDefinition';
import LabelCustom from './LabelCustom';
// ==============================|| File Row ||============================== //

const SheetRow = (props) => {
    const { id, sheetName, tool, editor, createdDate, reviewer, status } = props.fileInfo;
    const { currentUser } = props;
    const { t } = useTranslation();

    return (
        <TableRow hover key={id}>
            <TableCell align="left" width="20%">
                {sheetName}
            </TableCell>

            <TableCell align="left" sx={{ textTransform: 'capitalize' }} width="20%">
                {`${tool?.toolName} ${tool.versionId}`}
            </TableCell>

            <TableCell align="center" width="15%">
                {`${editor?.firstName} ${editor?.lastName}`}
            </TableCell>

            <TableCell align="center" width="15%">
                {`${reviewer?.firstName} ${reviewer?.lastName}`}
            </TableCell>

            <TableCell align="center" width="8%">
                {moment(createdDate).format('YYYY-MM-DD')}
            </TableCell>

            <TableCell align="center" width="8%">
                <LabelCustom
                    color={
                        (status === SheetStatus.COMPLETED && 'success') ||
                        (status === SheetStatus.EDITING && 'warning') ||
                        (status === SheetStatus.CHECKED && 'warning') ||
                        (status === SheetStatus.REVIEWING && 'primary') ||
                        (status === null && 'primary')
                    }
                    sx={{ textTransform: 'capitalize', width: '100%' }}
                >
                    {t(`calculationTable.${status}`)}
                </LabelCustom>
            </TableCell>

            {currentUser?.company?.companyName === CompanyDefinition.NKE && (
                <TableCell align="center" width="12%">
                    <IconButton onClick={() => props.onEditFile(props.fileInfo)} disabled={status === SheetStatus.COMPLETED}>
                        <Tooltip title={<Trans i18nKey="calculationTable.edit" />} placement="bottom">
                            <EditIcon style={{ marginRight: '10%', cursor: 'pointer' }} />
                        </Tooltip>
                    </IconButton>

                    <>
                        <IconButton onClick={() => props.onCopyToNewFile(props.fileInfo)}>
                            <Tooltip title={<Trans i18nKey="calculationTable.copy" />} placement="bottom">
                                <ContentCopy style={{ marginRight: '10%', cursor: 'pointer' }} />
                            </Tooltip>
                        </IconButton>

                        <IconButton onClick={() => props.onDownloadSheet(props.fileInfo)} disabled={status !== SheetStatus.COMPLETED}>
                            {props?.downloadingSheet?.sheetId === id && props?.downloadingSheet?.downloading ? (
                                <Tooltip title={<Trans i18nKey="calculationTable.downloading" />} placement="bottom">
                                    <CircularProgress size="1.5rem" style={{ color: '#02457a' }} />
                                </Tooltip>
                            ) : (
                                <Tooltip title={<Trans i18nKey="calculationTable.download" />} placement="bottom">
                                    <DownloadIcon style={{ marginRight: '10%', cursor: 'pointer' }} />
                                </Tooltip>
                            )}
                        </IconButton>

                        <IconButton
                            onClick={() => props.onDeleteSheet(props.fileInfo)}
                            sx={{
                                fontSize: '1.25rem',
                            }}
                        >
                            <Tooltip title={<Trans i18nKey="calculationTable.moveToTrash" />} placement="bottom">
                                <Delete style={{ marginRight: '10%', cursor: 'pointer' }} />
                            </Tooltip>
                        </IconButton>
                    </>
                </TableCell>
            )}

            <TableCell align="center" width="8%">
                <IconButton onClick={() => props.onOpenSheet(props.fileInfo)}>
                    <Tooltip title={<Trans i18nKey="calculationTable.navigate" />} placement="bottom">
                        {/* <OutputIcon /> */}
                        <FolderOpenFilled style={{ cursor: 'pointer', fontSize: '20px' }} />
                    </Tooltip>
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default SheetRow;
